import React from "react";
import { Row, Col } from "react-bootstrap";
import Theme from "./Theme";
import Skill from "./Skill";
import Coding from "./Coding";
import Finance from "./Finance";
import './messagecard.css';
const messageCard = () => {
  return (
    <div style={{ marginBottom: "1.5rem" }}>
      <h3
        style={{
          marginTop: "2rem",
          textAlign: "center",
          marginLeft: "-2rem",
          fontFamily: "Inter",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "42px",
          lineHeight: "51px",
        }}
      >
        Highlights
      </h3>
      <div className="highlightss">
        <Row>
          <Col style={{ display: "flex", justifyContent: "center" }}>
            <Theme />
          </Col>
          <Col style={{ display: "flex", justifyContent: "center" }}>
            <Skill />
          </Col>
        </Row>
        <Row>
          <Col style={{ display: "flex", justifyContent: "center" }}>
            <Coding />
          </Col>
          <Col style={{ display: "flex", justifyContent: "center" }}>
            <Finance />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default messageCard;
